import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, MapPin } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { LocalGuide } from "./LocalGuide";
import { useT } from "@/lib/i18n";

export const Attractions = () => {
  const { t } = useT();
  return (
    <section id="atrakcie" className="section-y" aria-labelledby="atrakcie-title">
      <div className="container-x">
        <SectionHeader kicker={t.attractionsSection.kicker} title={t.attractionsSection.title} subtitle={t.attractionsSection.subtitle} />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="attractions-grid">
          {t.attractions.map((a, idx) => (
            <motion.a
              key={a.name}
              href={a.href}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: idx * 0.08 }}
              className="group rounded-2xl border border-border bg-card shadow-soft overflow-hidden hover:-translate-y-0.5 hover:shadow-lifted hover:border-foreground/10 transition-[box-shadow,transform,border-color] duration-200 flex flex-col"
              data-testid={`attraction-card-${idx}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-muted">
                <img src={a.image} alt={a.name} width="900" height="675" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.05]" />
                <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-medium text-foreground shadow-soft">
                  <MapPin className="h-3.5 w-3.5" />
                  {a.distance}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display text-xl font-semibold text-foreground">{a.name}</h3>
                  <ExternalLink className="h-4 w-4 text-muted-foreground group-hover:text-foreground transition-transform duration-200 group-hover:translate-x-0.5 shrink-0 mt-1" />
                </div>
                <p className="mt-2 text-sm text-foreground/80 leading-relaxed">{a.body}</p>
              </div>
            </motion.a>
          ))}
        </div>

        <LocalGuide />
      </div>
    </section>
  );
};
